
<app-nav-bar></app-nav-bar>
<!-- banner slider -->
<div id="heroCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-touch="true">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" class="active" aria-current="true"
      aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <div class="hero-section">
        <div class="container">
          <div class="row align-items-center gy-4">
            <div class="col-md-6 mb-4 mb-lg-0">
              <div class="hero-text">
                <h1>A Dating App With <br>A <span class="heading-gradient">Big Pop</span></h1>
                <p class="m-0">Discover love in the most playful way. Pop balloons to reveal matches and start
                  meaningful connections.</p>
              </div>
              <!-- <div class="banner-btns d-flex gap-3 flex-wrap">
              <a href="#" class="base-btn btn-black d-flex align-items-center gap-2"><i class="fa-brands fa-apple"></i> App Store</a>
              <a href="#" class="base-btn btn-white d-flex align-items-center gap-2"><i class="fa-brands fa-google-play"></i> Google Play</a>
              <button (click)="onAdminLogin()" class="base-btn btn-gradient d-flex align-items-center gap-2">
                <i class="fa-solid fa-user-shield"></i> Admin Login
              </button>
            </div> -->
              <div class="pic-reviews">
                <div class="review-avatars">
                  @for (avatar of reviewAvatars; track avatar.src) {
                  <img [src]="avatar.src" [alt]="avatar.alt" class="review-avatar">
                  }
                </div>
                <p class="fw-semibold mb-0">
                  <span class="heading-gradient">150+ Reviews </span> (4.9 of 5)<br>
                </p>
                <p>Our review world wide</p>
              </div>
            </div>

            <div class="col-md-6 text-center mob-img-slide">
              <div class="slide-image">
                <img src="assets/images/slide1.png" alt="App Mockup">

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="hero-section2">
        <div class="container">
          <div class="text-center">
            <h1>A <span class="heading-gradient">Dating App</span> With<br /> A Big Pop</h1>
          </div>
          <div class="row align-items-center gy-4">
            <div class="col-md-6">
              <div class="banner-text">
                <div class="hero-text">
                  <span class="quotes-icon"><i class="fa-solid fa-quote-left"></i></span>
                  <p class="m-0">Discover love in the most playful way. Pop balloons to reveal matches and start
                    meaningful connections.</p>
                </div>
                <!-- App Buttons -->
                <!-- <div class="banner-btns d-flex gap-3 flex-wrap">
                  <a href="#" class="base-btn btn-black d-flex align-items-center gap-2"><i class="fa-brands fa-apple"></i> App Store</a>
                  <a href="#" class="base-btn btn-white d-flex align-items-center gap-2"><i class="fa-brands fa-google-play"></i> Google Play</a>
                  <button (click)="onAdminLogin()" class="base-btn btn-gradient d-flex align-items-center gap-2">
                    <i class="fa-solid fa-user-shield"></i> Admin Login
                  </button>
                </div> -->

                <!-- Reviews -->
                    <div class="pic-reviews">
                <div class="review-avatars">
                  @for (avatar of reviewAvatars; track avatar.src) {
                  <img [src]="avatar.src" [alt]="avatar.alt" class="review-avatar">
                  }
                </div>
                <p class="fw-semibold mb-0">
                  <span class="heading-gradient">150+ Reviews </span> (4.9 of 5)<br>
                </p>
                <p>Our review world wide</p>
              </div>
              </div>
            </div>
            <div class="col-lg-6 text-center mobile-hero-img">
            <div class="slide-image">
              <img src="assets/images/slide2.png" alt="App Mockup">
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Experience the Magic section -->
<section class="features section-padding">
  <div class="container">
    <div class="section-head">
      <h2>Experience the <span class="heading-gradient">Magic</span></h2>
      <p>
        See how our app brings people together through playful interactions
      </p>
    </div>
    <div class="row gy-4">
      <div class="col-md-6">
        <div class="magic-box">
          <div class="phone-mockup">
            <img src="assets/images/match-pic.png" alt="App Mockup">
          </div>
          <div class="magic-text">
            <h4 class="heading-gradient">Pop to Match</h4>
            <p>Discover potential matches by popping colorful balloons in our unique interface</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="magic-box position-relative">
          <div class="phone-mockup">
            <img src="assets/images/real-time.png" alt="App Mockup">
          </div>
          <div class="magic-text">
            <h4 class="heading-gradient">Real-time Chat</h4>
            <p>Connect instantly with meaningful conversations and authentic connections</p>
          </div>
          <div class="contact-tag">
            <img src="assets/images/tag-contact.svg" alt="contact">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Why Choose Section -->
<section id="features" class="choose-us section-padding">
  <div class="container">
    <div class="section-head">
      <h2>Why Choose Adore The <span class="heading-gradient">Balloon?</span></h2>
      <p>Discover what makes our dating app special</p>
    </div>
    <div class="row gy-4">
      <div class="col-md-3">
        <div class="feature-card">
          <img src="assets/images/baloon.png" alt="Balloon Icon">
          <h5 class="heading-gradient">Balloon Pop</h5>
          <p>Unique matching experience through interactive balloon popping</p>
        </div>
      </div>

      <div class="col-md-3">
        <div class="feature-card">
          <img src="assets/images/calendar.png" alt="calendar Icon">
          <h5 class="heading-gradient">Group Dating</h5>
          <p>Meet people in fun group settings and social events</p>
        </div>
      </div>

      <div class="col-md-3">
        <div class="feature-card">
          <img src="assets/images/email-pop.png" alt="email-popup Icon">
          <h5 class="heading-gradient">Voice Messages</h5>
          <p>Express yourself with authentic voice recordings</p>
        </div>
      </div>

      <div class="col-md-3">
        <div class="feature-card">
          <div class="avatar-border-wrap">
            <img src="assets/images/brand-images/brand-8.png" alt="Clara Icon" class="avatar-img">
          </div>
          <h5 class="heading-gradient">Real-time Chat</h5>
          <p>Connect instantly with meaningful conversations</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- How It Works Section -->
<section id="how-it-works" class="how-works section-padding">
  <div class="container">
    <div class="section-head">
      <h2>How it <span class="heading-gradient">Works</span></h2>
      <p>Get started in three simple steps</p>
    </div>
    <div class="row align-items-center gy-4">
      <div class="col-md-6">
        <div class="work-step-img">
          <img src="assets/images/profile.png" alt="Create Profile Screen">
        </div>
      </div>

      <div class="col-md-6">
        <div class="step-text">
          <span>/ 01</span>
          <h3>Create Profile</h3>
          <p>Set up your profile with photos and preferences to get started</p>
          <div>
            <a href="#" class="base-btn gradient-btn mt-3">Learn More</a>
          </div>
        </div>
      </div>

      <div class="row align-items-center gy-4">
        <div class="col-md-6 order-2 order-md-1">
          <div class="step-text">
            <span>/ 02</span>
            <h3>Pop Balloons</h3>
            <p>Discover potential matches by popping colorful balloons</p>
            <div>
              <a href="#" class="base-btn gradient-btn mt-3">Learn More</a>
            </div>
          </div>
        </div>
        <div class="col-md-6 order-1 order-md-2">
          <div class="work-step-img">
            <img src="assets/images/pop-ballon.png" alt="Pop balloon Screen">
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="work-step-img">
          <img src="assets/images/start-chat.png" alt="start-chat Screen">
        </div>
      </div>

      <div class="col-md-6">
        <div class="step-text">
          <span>/ 03</span>
          <h3>Start Chatting</h3>
          <p>Connect with matches and build meaningful relationships</p>
          <div>
            <a href="#" class="base-btn gradient-btn mt-3">Learn More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- cta section -->
<section id="Download" class="download-adore">
  <div class="container">
    <div class="cta-section position-relative">
      <img src="assets/images/two-hearts.png" alt="Hearts" class="icon">
      <div class="cta-content">
        <h2 class="mb-3">Ready to Find Love?</h2>
        <p class="pb-2">Download Adore The Balloon today and start your journey to meaningful connections</p>
        <div class="d-flex gap-3 mt-4 justify-content-center flex-wrap">
          <a href="#" (click)="onAppStoreClick($event, 'apple')"
            class="base-btn btn-black d-flex align-items-center gap-2 justify-content-center">
            @if (isAppleLoading) {
            <i class="pi pi-spin pi-spinner"></i>
            } @else {
            <i class="fa-brands fa-apple"></i>
            }
            App Store
          </a>

          <a href="https://play.google.com/store/apps/details?id=com.poptheballon.insizion"
            (click)="onAppStoreClick($event, 'android')"
            class="base-btn btn-white d-flex align-items-center gap-2 justify-content-center">
            @if (isAndroidLoading) {
            <i class="pi pi-spin pi-spinner"></i>
            } @else {
            <i class="fa-brands fa-google-play"></i>
            }
            Google Play
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer-banner></app-footer-banner>